/*global addthis_share:true*/
/*eslint no-undef: "error"*/

import { tokenToTagsMapping } from '../twitter/tags';

class ShareService {
  titleUpdateNetworks = ['twitter', 'facebook', 'linkedin'];

  setupPage({ tags, title, fullTitle, isTitlePrefixOn = true, isAutoDefaultTagsOn = true, twitterRefs = [] }) {
    fullTitle = fullTitle === undefined ? title : fullTitle;
    document.title = `${fullTitle}${fullTitle.length > 0 ? ' - ' : ''}Dor Moshe's Blog`;

    if (isTitlePrefixOn) {
      title = `${title} - Dor Moshe's Blog`;
    }
    
    addthis_share.title = title;

    tags = (tags && tags.length > 0) ? tags : (isAutoDefaultTagsOn ? ['javascript', 'webdev',] : []);
    let { twitterTitle, twitterTags } = this.getTwitterTitleAndTags(title, tags);
    if (twitterRefs && twitterRefs.length > 0) {
      twitterTitle += ` @${twitterRefs.join(' @')}`;
    }

    Object.assign(addthis_share.passthrough.twitter, {
      hashtags: twitterTags.join(',').split('-').join(''),
      text: twitterTitle,
      // related: twitterRefs.join(',')
    });
  }

  getTwitterTitleAndTags(title, tags, moreToSave = 18) { // via part
    let lowerCaseTitleParts = title.toLowerCase().split(' ');
    let originalTitleParts = title.split(' ');
    let relevantTags = [];
    tags.forEach((tag) => {
      const titlePartIndex = lowerCaseTitleParts.indexOf(tag.toLowerCase());

      if (titlePartIndex > -1) {
        originalTitleParts[titlePartIndex] = `#${originalTitleParts[titlePartIndex]}`;
        return;
      }
      
      relevantTags.push(tag);
    }, this);

    originalTitleParts = originalTitleParts.map((token) => {
      const lcToken = token.toLowerCase();
      const newToken = tokenToTagsMapping[lcToken];
      if (newToken) {
        relevantTags = relevantTags.filter(tag => {
          const lcTag = tag.toLowerCase();
          return lcTag !== lcToken && lcTag !== newToken.toLowerCase();
        });

        return `#${newToken}`;
      }

      return token;
    });

    const maxTotalSize = 280 - 5 - 24 - moreToSave; // MAX SIZE - GAP - url length - moreToSave (via part)
    let availableLength = maxTotalSize - title.length;
    const resultedTags = relevantTags.filter((tag) => {
      const tagLength = tag.length + 2; // # and space
      if (tagLength <= availableLength) {
        availableLength -= tagLength;
        return true;
      }

      return false;
    });

    return {
      twitterTitle: originalTitleParts.join(' '),
      twitterTags: resultedTags
    };
  }
}

const shareService = new ShareService();

export default shareService;